import { Component, Input, OnInit } from '@angular/core';
import { containerConstants } from './container-header.constants';

@Component({
  selector: 'app-container-header',
  templateUrl: './container-header.component.html',
  styleUrls: ['./container-header.component.scss']
})
export class ContainerHeaderComponent implements OnInit {

  @Input('type') type = '';
  containerConstants = containerConstants;

  constructor() { }

  ngOnInit() {
  }

}
